"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/styles");
var _Donut = _interopRequireDefault(require("./Donut.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// ASSETS

var Donut = function Donut(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size,
    _ref$strokeWidth = _ref.strokeWidth,
    strokeWidth = _ref$strokeWidth === void 0 ? 3 : _ref$strokeWidth,
    _ref$percentage = _ref.percentage,
    percentage = _ref$percentage === void 0 ? 0 : _ref$percentage,
    backgroundColor = _ref.backgroundColor,
    activeColor = _ref.activeColor;
  var classes = (0, _Donut.default)();
  var theme = (0, _styles.useTheme)();
  var strokeDash = percentage / 50 * (size + size * 0.275);
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: classes.donut,
    viewBox: "0 0 ".concat(size, " ").concat(size),
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    fill: "none",
    strokeWidth: strokeWidth,
    stroke: backgroundColor || theme.palette.NEUTRAL040,
    cx: "50%",
    cy: "50%",
    r: "40%"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    fill: "none",
    strokeWidth: strokeWidth,
    stroke: activeColor || theme.palette.BLUE400,
    cx: "50%",
    cy: "50%",
    r: "40%",
    strokeDasharray: "".concat(strokeDash, ", 100")
  }));
};
var _default = Donut;
exports.default = _default;